<template>
    <portal
        v-if="isOpen"
        to="modals"
    >
        <modal-backdrop
            :is-open="isOpen"
            @close="close"
        >
            <modal-window
                :is-open="isOpen"
                class="max-w-sm"
                @close="close"
            >
                <div class="w-full h-8" />

                <div class="relative w-full bg-white rounded shadow-lg">
                    <div class="absolute inset-x-0 top-0 h-1 rounded-t bg-red" />

                    <div class="absolute inset-x-0 top-0 -mt-6 md:-mt-8">
                        <base-svg
                            name="icon-important-circle-large"
                            class="w-12 h-12 mx-auto fill-primary-red fill-secondary-red-lighter md:w-16 md:h-16"
                        />
                    </div>

                    <div class="p-6 pt-8 text-center md:pt-12">
                        <slot name="content">
                            <h6 class="mb-3 text-lg font-normal font-semibold">
                                <slot name="heading">Error!</slot>
                            </h6>

                            <div class="text-grey-darker">
                                <slot />

                                <p class="mt-3 text-sm">
                                    p.s. If you keep seeing this error, please
                                    <laroute-link
                                        :to="{
                                            name: 'www.contact.index'
                                        }"
                                        class="no-underline text-blue"
                                    >
                                        get in touch.
                                    </laroute-link>
                                </p>
                            </div>
                        </slot>
                    </div>

                    <div class="px-6 py-3 rounded-b bg-grey-bg">
                        <slot
                            :close="close"
                            name="footer"
                        />
                    </div>
                </div>
            </modal-window>
        </modal-backdrop>
    </portal>
</template>

<script>
    import ModalBackdrop from './modal-backdrop'
    import ModalWindow from './modal-window.vue'

    export default {
        components: {
            ModalBackdrop,
            ModalWindow
        },
        model: {
            prop: 'isOpen',
            event: 'close'
        },
        props: {
            isOpen: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            close () {
                this.$emit('close', false)
            }
        }
    }
</script>
